//NOTE: This is the tracking schema version. In needs to be used in this lib and tracking
//because of circular dep restriction we need to keep it here
export const EXP_VIEWED_VERSION = '1-0-0';
